<p-dialog
  [(visible)]="openDialog"
  [header]="'Vaka İle İlişkili Faturalar'"
  [modal]="true"
  (onHide)="clearData()"
  [style]="{ width: '80vw' }"
  [closable]="true"
  appendTo="body"
>
  <div class="copy-notification" [class.show]="showCopied">
    {{ "bills.logs.copy" | translate }}
  </div>
  <div class="card">
    <div class="table-responsive active-projects user-tbl dt-filter">
      <div id="user-tbl_wrapper" class="dataTables_wrapper no-footer">
        <p-table
          #dt
          [value]="bills"
          dataKey="id"
          [scrollable]="true"
          scrollHeight="60vh"
          [rowHover]="true"
          responsiveLayout="stack"
          [totalRecords]="totalRecords"
          [rowTrackBy]="trackById"
          [tableStyle]="{ 'table-layout': 'fixed', width: '100%' }"
        >
          <ng-template pTemplate="colgroup">
            <colgroup>
              <col style="width: 7rem" />
              <col style="width: 10rem" />
              <col style="width: 5rem" />
              <col style="width: 7rem" />
              <col style="width: 5rem" />
              <col style="width: 5rem" />
              <col style="width: 10rem" />
              <col style="width: 12rem" />
              <col style="width: 10rem" />
            </colgroup>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th pFrozenColumn pSortableColumn="id" scope="col">
                {{ "bills.billed.id" | translate }}
                <p-sortIcon field="id" />
              </th>
              <th scope="col">
                {{ "bills.billed.bill-no" | translate }}
              </th>
              <th pSortableColumn="billingDate" scope="col">
                {{ "bills.billed.bill-date" | translate }}
                <p-sortIcon field="billingDate" />
              </th>

              <th scope="col">
                {{ "bills.billed.bill-status" | translate }}
              </th>

              <th scope="col">
                {{ "bills.billed.e-archive-status" | translate }}
              </th>

              <th scope="col">
                {{ "bills.billed.e-archive-step" | translate }}
              </th>

              <th scope="col">
                {{ "bills.billed.bill-receiver" | translate }}
              </th>
              <th scope="col"></th>

              <th pFrozenColumn alignFrozen="right" scope="col"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-bill>
            <tr>
              <td pFrozenColumn>
                {{ bill?.id }}
                <i
                  class="pi pi-copy pointer"
                  (click)="copySText(bill, 'id')"
                  role="button"  tabindex="-1"
                ></i>
              </td>

              <td>
                {{ bill?.billNo }}
                <i
                  *ngIf="bill?.billNo"
                  class="pi pi-copy pointer"
                  (click)="copySText(bill, 'billNo')"
                  role="button"  tabindex="-1"
                ></i>
              </td>

              <td>
                {{ bill?.billingDate | dateFormat : true }}
              </td>

              <td>
                <span class="badge light border-0 badge-warning">
                  {{ bill?.billStatus | billStatusPipe }}
                </span>
              </td>

              <td>
                @if(bill?.eArchiveStatus===2){
                <i
                  [coreTooltip]="'Gönderildi'"
                  class="fa fa-check"
                  style="color: green"
                ></i>

                }@else if(bill?.eArchiveStatus===3) {
                <i
                  [coreTooltip]="'Hatalı Gönderim'"
                  class="fa fa-xmark"
                  style="color: red"
                ></i>
                } @else if(bill?.eArchiveStatus===1) {
                <i
                  [coreTooltip]="'Gönderilmedi'"
                  class="fa fa-xmark"
                  style="color: rgb(255, 187, 0)"
                ></i>
                }
              </td>

              <td>
                @if(bill?.eArchiveStepStatus===2){
                <i
                  [coreTooltip]="'İşlem Başarılı'"
                  class="fa fa-check"
                  style="color: green"
                ></i>

                }@else if(bill?.eArchiveStepStatus===1) {
                <i
                  [coreTooltip]="'İşlem Devam Ediyor'"
                  class="fa-solid fa-hourglass-start"
                  style="color: rgb(255, 204, 0)"
                ></i>
                } @else if(bill?.eArchiveStepStatus===-1) {
                <i
                  [coreTooltip]="'İşlem Başarısız'"
                  class="fa fa-xmark"
                  style="color: red"
                ></i>
                }
              </td>

              <td>
                {{ bill?.personFullname ?? bill?.institutionName }}
              </td>

              <td>
                <div class="bill-summary-cell">
                  <div class="bill-summary-rows">
                    <div class="summary-row">
                      <span class="label">KDV’siz Tutar:</span>
                      <span class="value">{{
                        bill?.vatFreeAmount
                          | currency : "TRY" : "symbol" : "1.2-2"
                      }}</span>
                    </div>

                    <div class="summary-row">
                      <span class="label">KDV Oranı:</span>
                      <span class="value">{{ bill?.kdvRate }}%</span>
                    </div>

                    <div class="summary-row">
                      <span class="label">KDV Tutarı:</span>
                      <span class="value">{{
                        bill?.kdvAmount | currency : "TRY" : "symbol" : "1.2-2"
                      }}</span>
                    </div>

                    <div class="summary-row">
                      <span class="label">Toplam Tutar:</span>
                      <span class="value">{{
                        bill?.amount | currency : "TRY" : "symbol" : "1.2-2"
                      }}</span>
                    </div>
                  </div>
                </div>
              </td>

              <td
                class="actions"
                pFrozenColumn
                alignFrozen="right"
                (click)="$event.stopPropagation()" role="button"  tabindex="-1"
              >
                <p-button
                  *ngIf="bill?.eArchiveStepStatus===2 && bill?.eArchiveStatus===2"
                  icon="pi pi-image"
                  (onClick)="getBillDocument(bill?.id)"
                  [rounded]="true"
                  severity="success"
                  size="small"
                  class="me-2"
                  coreTooltip="Fatura Görüntüle"
                >
                </p-button>
                <p-button
                 *ngIf="bill?.eArchiveStepStatus===2 && bill?.eArchiveStatus===2"
                  icon="pi pi-envelope"
                  [rounded]="true"
                  severity="help"
                  size="small"
                  coreTooltip="E-mail Gönder"
                  (onClick)="sendDocEmail(bill?.id, bill?.email)"
                >
                </p-button>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="paginatorleft">
            {{ totalRecords }} {{ "common.table.totalFound" | translate }}
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="99">{{ "common.noData" | translate }}</td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="99">
                {{ "common.noData" | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</p-dialog>

<app-loading [loading]="loading" [fullScreen]="true"></app-loading>
<app-send-bill-document-email #sendEmail></app-send-bill-document-email>
